import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { Button, message, Modal } from "antd";
import ProjectStore from "../../../../stores/Admin/ProjectStore";
import styles from "./index.module.scss";
import { get, post } from "../../../../services/request";
import { GET_TAG_BY_ID, EDIT_TAG } from "../../../../services/request/urls";
import TagLabelDialog from "./dialogs";
import AppStore from "../../../../stores/User/AppStore";
export interface TagLabelProps {
  id: number;
}
const TagLabel: React.FC<TagLabelProps> = (props) => {
  const { id } = props;
  const [visibles, setVisibles] = useState<boolean>(false);
  const [otherTag, setOtherTag] = useState<{ id: string; name: string }[]>([]);
  const [industryTag, setIndustryTag] = useState<{
    id: string;
    name: string;
  }>({ id: "", name: "" });
  const getTagByid = async function (id: number) {
    const res = await get(GET_TAG_BY_ID + "?id=" + id, null, true);
    if (res?.code !== 1) {
      message.error(res?.message ?? "获取标签列表失败");
      return;
    }
    setOtherTag(res?.data.otherTagVoList);
    setIndustryTag(res?.data.industryTagVo);
  };
  useEffect(() => {
    getTagByid(id);
  }, [id]);
  const editTag = async function (
    id: string,
    industryTag: string,
    otherTagList: string[]
  ) {
    const res = await post(EDIT_TAG, { id, industryTag, otherTagList }, true);
    if (res?.code !== 1) {
      message.error(res?.message ?? "编辑失败");
      return;
    }
    message.success("编辑成功");
    getTagByid(Number(id));
  };
  return (
    <div className={styles.project_tag}>
      <div className={styles.tag_info}>
        <div>行业标签：{industryTag?.name}</div>

        <div>
          其他标签：
          {Array.isArray(otherTag) &&
            otherTag.map((item) => <span key={item.id}>{item.name}</span>)}
        </div>
      </div>
      <Button
        shape="round"
        type="primary"
        onClick={() => {
          setVisibles(true);
          AppStore.getTag();
        }}
      >
        修改
      </Button>
      <TagLabelDialog
        id={id}
        visible={visibles}
        otherTag={otherTag}
        industryTag={industryTag}
        close={() => setVisibles(false)}
        submit={editTag}
      />
    </div>
  );
};

export default observer(TagLabel);
